// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"1c29f5f2","377":"c1855308"}[chunkId] + ".chunk.js";
};